import { render, staticRenderFns } from "./Bitrix.vue?vue&type=template&id=5acb21c8&scoped=true"
import script from "./Bitrix.vue?vue&type=script&lang=js"
export * from "./Bitrix.vue?vue&type=script&lang=js"
import style0 from "./Bitrix.vue?vue&type=style&index=0&id=5acb21c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acb21c8",
  null
  
)

export default component.exports